import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import * as React from 'react';
import {CSSProperties} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon, Popup} from 'semantic-ui-react';

import {RunSignature} from '../../types/run';
import {downloadSpritePart} from './downloadSpritePart';

const Image = ({
  step,
  imgRef,
  imageURL,
  imgStyle,
  trackSuccess,
  trackError,
  rolledBack,
  globalStep,
  filePath,
  originalWidth,
  originalPixelOffset,
  runSignature,
  boxesRef,
  masksRef,
}: {
  step: number;
  imgRef: React.RefObject<HTMLImageElement>;
  imageURL: string;
  imgStyle: CSSProperties;
  trackSuccess: () => void;
  trackError: () => void;
  rolledBack: boolean;
  globalStep: number;
  filePath: string;
  originalWidth?: number | null;
  originalPixelOffset: number;
  runSignature: RunSignature;
  boxesRef?: React.RefObject<HTMLDivElement>;
  masksRef?: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <div>
      <img
        data-test={`image-card-img-${step}`}
        ref={imgRef}
        src={imageURL}
        alt="card"
        style={imgStyle}
        onLoad={trackSuccess}
        onError={trackError}
      />
      {rolledBack && (
        <div className={'content-card__fallback'}>
          <Popup
            trigger={
              <Icon
                style={{color: 'white'}}
                size="small"
                name="exclamation circle"
              />
            }>
            No media was found for step: {globalStep}
            <br />
            The most recent step: {step} is being displayed
          </Popup>
        </div>
      )}

      {filePath && originalWidth && (
        <LegacyWBIcon
          className="content-card__download"
          onClick={() => {
            downloadSpritePart(
              runSignature,
              filePath,
              originalPixelOffset,
              originalWidth,
              {boxesRef, masksRef}
            );
          }}
          name="download"
        />
      )}
    </div>
  );
};

export default Image;
